import ActivityType from './Headers/ActivityType';
import BusinessOwner from './Headers/BusinessOwner';
import { DateCreated } from './Headers/DateCreated';
import Lifecycle from './Headers/Lifecycle';
import Managed from './Headers/Managed';
import Risk from './Headers/Risk';
import { SSO } from './Headers/SSO';
import SSOCoverageHeader from './Headers/SSOCoverageHeader';
import { SourceHeaderHelper } from './Headers/SourceHeader';

const Headers = (theme) => {
    const SourceHeader = SourceHeaderHelper(theme);
    const DateCreatedHeader = DateCreated();

    return {
        ActivityType,
        BusinessOwner,
        DateCreatedHeader,
        Lifecycle,
        Managed,
        Risk,
        SourceHeader,
        SSO: SSO(),
        SSOCoverageHeader
    };
};

// TODO: remove old headers once we migrate table to new V2 table
export { releaseHeader } from './Headers/ReleasesV2';

export default Headers;
